import { hasDirectoryTraversal } from 'notable-common';
import { ExternalDocumentPacketExportReason } from 'primary-schema';
import { z } from 'zod';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowConsumerOfExternalDocumentPacketSchema } from '../consumer.js';
import { FlowBlockType } from '../type.js';
export const FlowExportExternalDocumentPacketBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.ExportExternalDocumentPacket),
    config: z.object({
        externalDocumentPacket: FlowConsumerOfExternalDocumentPacketSchema,
        exportReason: z.enum(ExternalDocumentPacketExportReason),
        filePath: z
            .string()
            .optional()
            .refine((filePath) => !hasDirectoryTraversal(filePath), {
            message: 'Directory traversal attempts (..) are not allowed in file paths',
        }),
    }),
});
//# sourceMappingURL=config.js.map